export default __webpack_public_path__ + "static/media/Memo Shortcut 2.ea5c4ace.png";